import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./DetailsCommande.scss";
import "../Admin/AdminModern.scss";
import React, { useEffect, useState } from "react";
import NavBarProfil from "../../components/NavBarProfil/NavBarProfil";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faCheck, faCircleInfo, faTruck, faTruckFast, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { Loader } from "../../utils/Loader";
import Swal from "sweetalert2";
import VerifyRoleInJWTtoken from "../../services/VerifyRoleInJWTtoken";
import IsAdmin from "../../components/Admin/IsAdmin";
import AccountActiveOrNot from "../../components/AccountActiveOrNot/AccountActiveOrNot";
import ButtonDeconnect from "../../components/Button Deconnect/ButtonDeconnect";
import sendEmailOrderRefund from "../../services/SendEmailOrderRefund";
import TextAccountNotActiveWithDeconnectButton
    from "../../components/AccountActiveOrNot/TextAccountNotActiveWithDeconnectButton";

function DetailsCommande() {
    const location = useLocation();
    const [contenuCommande, setContenuCommande] = useState([]);
    const { idCommande } = useParams();
    const [commande, setCommande] = useState([]);
    const [user, setUser] = useState([]);
    const [adresseId, setAdresseId] = useState("");
    const [adresse, setAdresse] = useState({});
    const [pointRelaisId, setPointRelaisId] = useState("");
    const [pointRelais, setPointRelais] = useState({});
    const jwtToken = Cookies.get("auth_token");
    const [dataLoading, setDataLoading] = useState(false);
    const [dataLoadingCancelOrder, setDataLoadingCancelOrder] = useState(false);
    const [annulerCommande, setAnnulerCommande] = useState(false);
    const [stripePaymentCancel, setStripePaymentCancel] = useState("");
    const date = new Date();
    const dateCorrecte = new Date(commande.date);
    const [prixTotalProduits, setPrixTotalProduits] = useState(0);
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();
    dateCorrecte.setHours(dateCorrecte.getHours() + 2);
    const [accountActive, setAccountActive] = useState(null);
    const [raison, setRaison] = useState("");
    let raisonRefus = "";

    function inverserFormatDate(date) {
        const [annee, mois, jour] = date.split('-');
        return `${jour}-${mois}-${annee}`;
    }

    useEffect(() => {
        console.log(isAdmin)
        if (isAdmin === null) {
            return;
        }
    }, [isAdmin]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchCommande = async () => {
            setDataLoading(true);
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}commandes/${idCommande}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${jwtToken}`,
                        },
                    }
                );
                const commande = await response.json();
                console.log(commande);
                setCommande(commande);
                setAdresseId(commande.adresseLivraison);
                setPointRelaisId(commande.adressePointRelais);
                setContenuCommande(commande.contenuCommande);
                setDataLoading(false);

                const informationsUser = await fetch(`${process.env.REACT_APP_API_URL}users/get-user-by-id/${commande.idClient}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                });
                const user = await informationsUser.json();
                console.log(user);
                setUser(user);
            } catch (error) {
                console.error(error);
            }
        };
        fetchCommande();
        if (VerifyRoleInJWTtoken()) {
            setIsAdmin(true);
        }
    }, []);

    useEffect(() => {
        if (!adresseId) {
            return;
        }
        const fetchAdresse = async () => {
            console.log(adresseId);
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}adresses/${adresseId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`
                    },
                }
                );
                const adresse = await response.json();
                console.log(adresse);
                setAdresse(adresse);
            } catch (error) {
                console.error(error);
            }
        };
        fetchAdresse();
    }, [adresseId]);


    useEffect(() => {
        if (!pointRelaisId) {
            return;
        }
        const fetchPointRelais = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}mondialRelay/objectId/${pointRelaisId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`
                    },
                }
                );
                const pointRelai = await response.json();
                console.log(pointRelai);
                setPointRelais(pointRelai);
            } catch (error) {
                console.error(error);
            }
        };
        fetchPointRelais();
    }, [pointRelaisId]);

    const cancelOrder = async (raison) => {
        Swal.fire({
            text: `${raison === 'annulation' ? 'Etes vous sur de vouloir annuler votre commande ?' : 'Etes vous sur de vouloir rembourser cette commande ?'}`,
            icon: "warning",
            showConfirmButton: true,
            showCancelButton: true,
            cancelButtonText: "Annuler",
            confirmButtonText: `${raison === 'annulation' ? 'Oui supprimer' : 'Oui rembourser'}`
        }).then((result) => {
            if (result.isConfirmed) {
                setDataLoadingCancelOrder(true);
                try {
                    console.log(contenuCommande.idMoyenPaiementStripe)
                    const idModePaiement = commande.idMoyenPaiementStripe;
                    const cancelOrder = async () => {
                        const response = await fetch(
                            `${process.env.REACT_APP_API_URL}payment/cancel-order`,
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${jwtToken}`,
                                },
                                body: JSON.stringify({ token: idModePaiement })
                            }
                        );
                    };
                    cancelOrder();
                    setStripePaymentCancel(raison === "annulation" ? "Annulé" : "Remboursée");
                } catch (error) {
                    console.error(error);
                } finally {
                    setAnnulerCommande(false);
                }
            } else {
                setAnnulerCommande(false);
            }
        })
    }

    useEffect(() => {
        if (!annulerCommande) {
            return;
        }
        updateStatusCommande("Remboursée");
    }, [annulerCommande]);

    useEffect(() => {
        if (!stripePaymentCancel) {
            return;
        }
        try {
            const response = async () => {
                const setCancelOrder = await fetch(
                    `${process.env.REACT_APP_API_URL}commandes/update-status`,
                    {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${jwtToken}`,
                        },
                        body: JSON.stringify({ status: stripePaymentCancel, idCommande: idCommande })
                    }
                );

                if (stripePaymentCancel === "Remboursée" || stripePaymentCancel === "Non remboursée") {
                    await sendEmailOrderRefund(user, stripePaymentCancel, raison);
                }

                const commande = await setCancelOrder.json();
                if (commande) {
                    Swal.fire({
                        text: `${stripePaymentCancel === "Remboursée" ? "Commande remboursé avec succès" : stripePaymentCancel === "Non remboursée" ? "Commande non remboursée" : "Votre commande a bien été annulée"}`,
                        icon: "success",
                        showConfirmButton: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setCommande(commande);
                        }
                    })
                } else {
                    Swal.fire({
                        text: "Une erreur est survenue lors de l'annulation de votre commande",
                        icon: "error",
                        showConfirmButton: true,
                    });
                }
            };
            response();
        } catch (error) {
            console.error(error);
        } finally {
            setDataLoadingCancelOrder(false);
        }
    }, [stripePaymentCancel]);

    const sendOrder = async (idCommande, typeLivraison, idClient) => {
        const domicile = "colissimo";
        const pointRelais = "mondial relay";
        const lienEnvoiePointRelais = "https://www.mondialrelay.fr/envoi-de-colis/";
        const lienEnvoieDomicile = "https://www.laposte.fr/professionnel/envoi-colis/parcours/votre-colis";
        Swal.fire({
            title: "Tu t'apprêtes à valider l'envoi de la commande.",
            html: `J'aurais juste besoin que tu me fournisse le numéro de suivie ${typeLivraison === "A domicile" ? domicile : pointRelais}. Pour ceci, voici le lien ${typeLivraison === "A domicile" ? domicile : pointRelais} pour l'envoi : <a href='${typeLivraison === "A domicile" ? lienEnvoieDomicile : lienEnvoiePointRelais}' target='_blank'>${typeLivraison === "A domicile" ? lienEnvoieDomicile : lienEnvoiePointRelais}</a>.`,
            icon: "warning",
            input: 'text',
            inputPlaceholder: 'Entrez le numéro de suivi du colis',
            showCancelButton: true,
            preConfirm: (trackingNumber) => {
                if (!trackingNumber) {
                    Swal.showValidationMessage('Veuillez entrer le numéro de suivi du colis');
                }
                const commandeData = {
                    idCommande: idCommande,
                    trackingNumber: trackingNumber,
                    livraison: typeLivraison === "A domicile" ? domicile : pointRelais
                };
                try {
                    fetch(`${process.env.REACT_APP_API_URL}commandes/update-tracking-number`, {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${jwtToken}`,
                        },
                        body: JSON.stringify(commandeData),
                    });
                    Swal.fire({
                        title: "Numéro de suivie inséré",
                        icon: "success",
                    }).then(response => {
                        if (response.isConfirmed) {
                            sendEmailToClient();
                        }
                    });
                } catch (error) {
                    console.log(error);
                }
                const sendEmailToClient = async () => {
                    setDataLoading(true);
                    try {
                        const response = await fetch(`${process.env.REACT_APP_API_URL}users/get-user-by-id/${idClient}`, {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${jwtToken}`,
                            },
                        });
                        const client = await response.json();
                        const clientEmail = client.adresseEmail;
                        const clientName = client.prenom;
                        const transporteur = typeLivraison === "A domicile" ? "Colissimo" : "Mondial Relay";
                        console.log(clientEmail)
                        const Emailresponse = await fetch(`${process.env.REACT_APP_API_URL}mail/seller-to-client-order-sent`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                numeroSuivi: trackingNumber,
                                email: clientEmail,
                                name: clientName,
                                transporteur: transporteur
                            })
                        });
                        if (Emailresponse.ok) {
                            Swal.fire({
                                title: "Email envoyé au client avec succès",
                                icon: "success",
                            }).then((response) => {
                                if (response.isConfirmed) {
                                    window.location.reload();
                                }
                            });
                        }
                    } catch (error) {
                        console.log(error);
                    } finally {
                        setDataLoading(false);
                    }
                }
            },
        })
    }

    const updateStatusCommande = async (status) => {
        console.log(status);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}commandes/update-status`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Cookies.get("auth_token")}`,
                },
                body: JSON.stringify({ status: status, idCommande: idCommande })
            });
            const commandeBDD = await response.json();
            window.location.reload();
        } catch (error) {
            console.log(error);
        }
    }

    const sendEmailToSeller = async (raison) => {
        setDataLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}users/get-user-by-id/${commande.idClient}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            const client = await response.json();
            const clientEmail = client.adresseEmail;
            const clientName = client.prenom;
            const Emailresponse = await fetch(`${process.env.REACT_APP_API_URL}mail/client-to-seller-return-order-sent`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify({
                    name: clientName,
                    email: clientEmail,
                    raison: raison,
                    commande: commande
                })
            });
            if (Emailresponse.ok) {
                Swal.fire({
                    title: "Demande de retour envoyé avec succès, vous serez très bientôt informer par email de la réponse du vendeur.",
                    icon: "success",
                }).then((response) => {
                    if (response.isConfirmed) {
                        updateStatusCommande("Demande de retour");
                    }
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setDataLoading(false);
        }
    }

    const handleClickReturnOrder = () => {
        Swal.fire({
            title: "Retourner un produit",
            text: "Pour retourner un colis, le produit doit être dans son emballage d'origine et ne doit pas avoir été utilisé. Merci de choisir une raison de retour.",
            input: 'select',
            inputOptions: {
                option1: 'Ne me convient pas.',
                option2: 'Le produit a un défaut.',
            },
            inputPlaceholder: 'Raison de votre retour',
            showCancelButton: true,
            confirmButtonText: "Confirmer",
            preConfirm(inputValue) {
                if (!inputValue) {
                    Swal.showValidationMessage('Veuillez choisir une raison de retour');
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                let raison = result.value;
                switch (raison) {
                    case "option1":
                        raison = "Ne me convient pas.";
                        break;
                    case "option2":
                        raison = "Le produit a à un défaut";
                        break;
                    default:
                        raison = "Raison inconnue";
                        break;
                }
                console.log(raison);
                sendEmailToSeller(raison);
            }
        });
    }

    useEffect(() => {
        let total = 0;
        contenuCommande.forEach((commande) => {
            total += commande.price * commande.amount;
        });
        setPrixTotalProduits(total);
    }, [contenuCommande]);

    const handleClickRefundOrder = (raison) => {
        cancelOrder("annulation");
    }

    const sendEmailHowToReturnOrder = async (choix) => {
        try {
            console.log(choix, raisonRefus);
            const Emailresponse = await fetch(`${process.env.REACT_APP_API_URL}mail/how-return-order`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Cookies.get("auth_token")}`,
                },
                body: JSON.stringify({
                    email: user.adresseEmail,
                    choix: choix,
                    raison: raisonRefus,
                })
            });
            if (Emailresponse.ok) {
                Swal.fire({
                    title: "Demande de retour accepté / refusée avec succès.",
                    icon: "success",
                }).then((response) => {
                    if (response.isConfirmed) {
                        updateStatusCommande(choix);
                    }
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setDataLoading(false);
        }
    }

    return (
        <>
            <AccountActiveOrNot setAccountActive={setAccountActive} />
            <IsAdmin setAdmin={setIsAdmin} />
            {accountActive === false && accountActive !== null ? (
                <TextAccountNotActiveWithDeconnectButton />
            ) : (
                <div className="div-principal-detailsCommande">
                    <NavBarProfil></NavBarProfil>
                    {dataLoading ? (
                        <div className="loader-div-shopping-list">
                            <Loader />
                        </div>
                    ) : (
                        <div className="admin-modern-container" style={{ padding: "1rem", minHeight: "auto", background: "transparent" }}>
                            <div className="admin-header">
                                <h2>Détails de votre commande</h2>
                                <p>Commande N° {commande.idCommande}</p>
                            </div>
                            
                            <div className="admin-grid-2">
                                <div className="admin-card">
                                    <h4 style={{ marginBottom: "1rem", color: "var(--admin-primary)", borderBottom: "1px solid var(--admin-border)", paddingBottom: "0.5rem" }}>Informations Générales</h4>
                                    <p><b>Date :</b> {commande.date && inverserFormatDate(commande.date.substring(0, 10))}</p>
                                    
                                    <div style={{ margin: "1rem 0", display: "flex", alignItems: "center" }}>
                                        <b style={{ marginRight: "0.5rem" }}>Statut :</b>
                                        {commande.status === "Annulé" ? <span className="admin-badge admin-badge-danger"><FontAwesomeIcon icon={faCancel} style={{marginRight: "0.5rem"}}/> Annulé</span> :
                                         commande.status === "En cours de livraison" ? <span className="admin-badge admin-badge-info">En cours de livraison</span> :
                                         commande.status === "Livré" ? <span className="admin-badge admin-badge-success"><FontAwesomeIcon icon={faCheck} style={{marginRight: "0.5rem"}}/> Livré</span> :
                                         commande.status === "En cours de préparation" ? <span className="admin-badge admin-badge-warning">En cours de préparation</span> :
                                         commande.status === "Demande de retour" ? <span className="admin-badge admin-badge-warning">Demande de retour</span> :
                                         commande.status === "Demande de retour acceptée" ? <span className="admin-badge admin-badge-success"><FontAwesomeIcon icon={faCheck} style={{marginRight: "0.5rem"}}/> Retour accepté</span> :
                                         commande.status === "Remboursée" ? <span className="admin-badge admin-badge-success"><FontAwesomeIcon icon={faCheck} style={{marginRight: "0.5rem"}}/> Remboursée</span> :
                                         commande.status === "Non remboursée" ? <span className="admin-badge admin-badge-danger"><FontAwesomeIcon icon={faCancel} style={{marginRight: "0.5rem"}}/> Non remboursée</span> :
                                         commande.status === "Demande de retour refusée" ? <span className="admin-badge admin-badge-danger"><FontAwesomeIcon icon={faCancel} style={{marginRight: "0.5rem"}}/> Retour refusé</span> :
                                         <span className="admin-badge">Inconnu</span>}
                                    </div>
                                    <p><b>Type de livraison :</b> {commande.typeLivraison}</p>
                                </div>
                                
                                <div className="admin-card">
                                    <h4 style={{ marginBottom: "1rem", color: "var(--admin-primary)", borderBottom: "1px solid var(--admin-border)", paddingBottom: "0.5rem" }}>
                                        {commande.typeLivraison === "A domicile" ? "Adresse de livraison" : "Point Relais"}
                                    </h4>
                                    {commande.typeLivraison === "A domicile" ? (
                                        <div>
                                            <p style={{ margin: "0.25rem 0" }}>{adresse.adresse}</p>
                                            <p style={{ margin: "0.25rem 0" }}>{adresse.codePostal} {adresse.ville}</p>
                                            <p style={{ margin: "0.25rem 0" }}>{adresse.pays}</p>
                                        </div>
                                    ) : (
                                        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
                                            <div style={{ flex: 1 }}>
                                                <p style={{ margin: "0.25rem 0", fontWeight: "bold" }}>{pointRelais.enseigne}</p>
                                                <p style={{ margin: "0.25rem 0" }}>{pointRelais.adresse}</p>
                                                <p style={{ margin: "0.25rem 0" }}>{pointRelais.codePostal} {pointRelais.ville}</p>
                                                <p style={{ margin: "0.25rem 0" }}>{pointRelais.pays}</p>
                                            </div>
                                            {pointRelais.urlImage && (
                                                <div style={{ width: "80px", height: "80px", overflow: "hidden", borderRadius: "8px", flexShrink: 0 }}>
                                                    <img src={pointRelais.urlImage} alt="Point relais" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="admin-card" style={{ marginTop: "1rem" }}>
                                <h4 style={{ marginBottom: "1rem", color: "var(--admin-primary)", borderBottom: "1px solid var(--admin-border)", paddingBottom: "0.5rem" }}>Actions</h4>
                                
                                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                                    {commande.status === "En cours de préparation" && (dateCorrecte > date) && commande.status !== "Demande de retour" ? (
                                        dataLoadingCancelOrder ? <Loader /> : (
                                            <button className="admin-btn admin-btn-danger" onClick={() => handleClickRefundOrder("annulé")}>
                                                Annuler ma commande
                                            </button>
                                        )
                                    ) : commande.status !== "Annulé" && commande.status !== "En cours de préparation" && commande.status !== "Demande de retour" && commande.status !== "Demande de retour acceptée" && commande.status !== "Demande de retour refusée" && commande.status !== "Remboursée" && commande.status !== "Non remboursée" ? (
                                        <>
                                            <button className="admin-btn admin-btn-primary" onClick={() => {
                                                commande.typeLivraison === "En point relais" ? window.open(
                                                    "https://www.mondialrelay.fr/suivi-de-colis?numeroExpedition=" + commande.numeroSuivieMondialRelay + "&codePostal=" + commande.codePostalCommande,
                                                    "_blank"
                                                ) : window.open("https://www.laposte.fr/outils/suivre-vos-envois?code=" + commande.numeroSuivieColissimo, "_blank")
                                            }}>
                                                <FontAwesomeIcon icon={faTruckFast} style={{ marginRight: "0.5rem" }}/>
                                                Suivre mon colis
                                            </button>
                                            <button className="admin-btn admin-btn-outline" onClick={() => handleClickReturnOrder()}>
                                                <FontAwesomeIcon icon={faRotateLeft} style={{ marginRight: "0.5rem" }}/>
                                                Retourner un produit
                                            </button>
                                        </>
                                    ) : commande.status === "Demande de retour" ? (
                                        <div style={{ backgroundColor: "var(--admin-success-bg)", color: "var(--admin-success)", padding: "1rem", borderRadius: "8px", width: "100%" }}>
                                            Demande de retour envoyée avec succès au vendeur. Vous recevrez d'ici peu de temps une réponse par email de la part du vendeur.
                                        </div>
                                    ) : commande.status === "Demande de retour acceptée" ? (
                                        <div style={{ backgroundColor: "var(--admin-success-bg)", color: "var(--admin-success)", padding: "1rem", borderRadius: "8px", width: "100%" }}>
                                            Demande de retour acceptée. Vous avez reçu un mail avec les instructions à suivre pour renvoyer votre colis.
                                        </div>
                                    ) : commande.status === "Demande de retour refusée" ? (
                                        <div style={{ backgroundColor: "var(--admin-danger-bg)", color: "var(--admin-danger)", padding: "1rem", borderRadius: "8px", width: "100%" }}>
                                            Demande de retour refusée par le vendeur, vous pouvez avoir les détails du refus dans le mail envoyé.
                                        </div>
                                    ) : commande.status === "Annulé" ? (
                                        <div style={{ backgroundColor: "var(--admin-success-bg)", color: "var(--admin-success)", padding: "1rem", borderRadius: "8px", width: "100%" }}>
                                            Commande annulée avec succès. Votre commande vous a été remboursée, vous recevrez l'argent au maximum d'ici 5 jours.
                                        </div>
                                    ) : commande.status === "Remboursée" ? (
                                        <div style={{ backgroundColor: "var(--admin-success-bg)", color: "var(--admin-success)", padding: "1rem", borderRadius: "8px", width: "100%" }}>
                                            Commande remboursée avec succès. Vous recevrez l'argent d'ici 5 jours maximum. Si d'ici là vous ne recevez toujours pas votre argent, veuillez nous contacter par email en nous fournissant votre numéro de commande associé au remboursement.
                                        </div>
                                    ) : commande.status === "Non remboursée" && (
                                        <div style={{ backgroundColor: "var(--admin-danger-bg)", color: "var(--admin-danger)", padding: "1rem", borderRadius: "8px", width: "100%" }}>
                                            Commande non remboursée. Vous allez recevoir un email avec la raison de pourquoi cela.
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="admin-card" style={{ marginTop: "1rem" }}>
                                <h4 style={{ marginBottom: "1rem", color: "var(--admin-primary)", borderBottom: "1px solid var(--admin-border)", paddingBottom: "0.5rem" }}>
                                    Articles ({contenuCommande.nbArticles || contenuCommande.length})
                                </h4>
                                
                                <div className="admin-data-list">
                                    {commande && contenuCommande.length > 0 ? (
                                        contenuCommande.map((prod, idx) => (
                                            <div key={idx} className="admin-data-card" style={{ padding: "0.75rem", display: "flex", alignItems: "center", gap: "1rem", flexDirection: "row" }}>
                                                <div style={{ width: "60px", height: "60px", overflow: "hidden", borderRadius: "8px", flexShrink: 0 }}>
                                                    <img src={prod.cover} alt="produit" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <p style={{ margin: "0 0 0.25rem 0", fontWeight: "bold" }}>{prod.name}</p>
                                                    {prod.informationsComplementaires && (
                                                        <span className="admin-badge admin-badge-info" style={{ marginBottom: "0.25rem", fontSize: "0.75rem", display: "inline-flex" }}>
                                                            <FontAwesomeIcon icon={faCircleInfo} style={{ marginRight: "0.25rem" }}/>
                                                            {prod.informationsComplementaires}
                                                        </span>
                                                    )}
                                                    <p style={{ margin: 0, color: "var(--admin-text-muted)", fontSize: "0.9rem" }}>{prod.price} € x {prod.amount}</p>
                                                </div>
                                                <div style={{ fontWeight: "bold", fontSize: "1.1rem", color: "var(--admin-primary)" }}>
                                                    {(prod.price * prod.amount).toFixed(2)} €
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ textAlign: "center", color: "var(--admin-text-muted)", padding: "2rem" }}>
                                            Aucune commande pour le moment
                                        </div>
                                    )}
                                </div>
                                
                                <div style={{ marginTop: "1.5rem", borderTop: "2px dashed var(--admin-border)", paddingTop: "1.5rem", display: "flex", flexDirection: "column", gap: "0.5rem", alignItems: "flex-end" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%", maxWidth: "300px" }}>
                                        <span style={{ color: "var(--admin-text-muted)" }}>Total produits :</span>
                                        <span>{(prixTotalProduits).toFixed(2)} €</span>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%", maxWidth: "300px" }}>
                                        <span style={{ color: "var(--admin-text-muted)" }}>Frais de livraison :</span>
                                        <span>{commande.fraisLivraison} €</span>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%", maxWidth: "300px", fontSize: "1.2rem", fontWeight: "bold", color: "var(--admin-primary)", marginTop: "0.5rem" }}>
                                        <span>Total TTC :</span>
                                        <span>{commande.prixTotal && (commande.prixTotal).toFixed(2)} €</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!isAdmin ? null : (
                            <>
                                <div className="admin-modern-container" style={{ padding: "2rem 0 0 0", minHeight: "auto", backgroundColor: "transparent" }}>
                                    <div className="admin-card" style={{ border: "2px solid var(--admin-primary)", backgroundColor: "#f8fafc" }}>
                                        <div className="admin-header" style={{ textAlign: "left", marginBottom: "1.5rem" }}>
                                            <h2 style={{ color: "var(--admin-primary)" }}>Panel d'Administration</h2>
                                            <p>Gestion avancée de la commande</p>
                                        </div>
                                        
                                        <div className="admin-grid-2">
                                            <div className="admin-card" style={{ marginBottom: "0", boxShadow: "none" }}>
                                                <h4 style={{ marginBottom: "1rem", borderBottom: "1px solid var(--admin-border)", paddingBottom: "0.5rem" }}>Informations Client</h4>
                                                <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                                                    <p><b>Client :</b> {user.nom} {user.prenom}</p>
                                                    <p><b>Email :</b> {user.adresseEmail}</p>
                                                    <p><b>Civilité :</b> {user.civilite}</p>
                                                    <p><b>Téléphone :</b> {user.numeroTel}</p>
                                                </div>
                                            </div>
                                            
                                            <div className="admin-card" style={{ marginBottom: "0", boxShadow: "none" }}>
                                                <h4 style={{ marginBottom: "1rem", borderBottom: "1px solid var(--admin-border)", paddingBottom: "0.5rem" }}>Actions Rapides</h4>
                                                <div style={{ marginBottom: "1.5rem" }}>
                                                    <b>Statut actuel :</b> <span className="admin-badge admin-badge-warning">{commande.status}</span>
                                                </div>
                                                
                                                <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
                                                    {commande.status === "En cours de préparation" && (
                                                        <button className="admin-btn admin-btn-primary"
                                                            onClick={() => sendOrder(commande.idCommande, commande.typeLivraison, commande.idClient)}>
                                                            Valider l'envoi
                                                        </button>
                                                    )}
                                                    
                                                    {commande.status === "En cours de livraison" && (
                                                        <button className="admin-btn admin-btn-outline" style={{ color: "#2563eb", borderColor: "#bfdbfe" }}
                                                            onClick={() => window.open(
                                                                commande.typeLivraison === "En point relais" ? "https://www.mondialrelay.fr/suivi-de-colis?numeroExpedition=" + commande.numeroSuivieMondialRelay + "&codePostal=" + commande.codePostalCommande
                                                                    : "https://www.laposte.fr/outils/suivre-vos-envois?code=" + commande.numeroSuivieColissimo,
                                                                "_blank"
                                                            )}>
                                                            Suivre le colis
                                                        </button>
                                                    )}
                                                    
                                                    {commande.status === "Demande de retour" && (
                                                        <div style={{ display: "flex", gap: "0.5rem", flexDirection: "column" }}>
                                                            <button className="admin-btn admin-btn-primary" style={{ backgroundColor: "var(--admin-success)" }}
                                                                onClick={() => {
                                                                    Swal.fire({
                                                                        title: "Accepter la demande de retour",
                                                                        text: "Cela enverra un email au client avec les étapes à suivre pour renvoyer son colis.",
                                                                        icon: "warning",
                                                                        showCancelButton: true,
                                                                        confirmButtonText: "Oui, accepter",
                                                                    }).then((result) => {
                                                                        if (result.isConfirmed) {
                                                                            sendEmailHowToReturnOrder("Demande de retour acceptée");
                                                                        }
                                                                    });
                                                                }}>
                                                                Accepter le retour
                                                            </button>
                                                            <button className="admin-btn admin-btn-danger"
                                                                onClick={() => {
                                                                    Swal.fire({
                                                                        title: "Refuser la demande de retour",
                                                                        text: "Etes vous sur de vouloir refuser la demande de retour ?",
                                                                        icon: "warning",
                                                                        showCancelButton: true,
                                                                        confirmButtonText: "Oui, refuser",
                                                                        input: 'text',
                                                                        inputPlaceholder: 'Raison du refus',
                                                                        preConfirm(raisonConfirm) {
                                                                            if (!raisonConfirm) {
                                                                                Swal.showValidationMessage('Veuillez choisir une raison de refus');
                                                                            }
                                                                            raisonRefus = raisonConfirm;
                                                                        },
                                                                    }).then((result) => {
                                                                        if (result.isConfirmed) {
                                                                            sendEmailHowToReturnOrder("Demande de retour refusée", raison);
                                                                        }
                                                                    });
                                                                }}>
                                                                Refuser le retour
                                                            </button>
                                                        </div>
                                                    )}
                                                    
                                                    {commande.status === "Demande de retour acceptée" && (
                                                        <div style={{ display: "flex", gap: "0.5rem", flexDirection: "column" }}>
                                                            <button className="admin-btn admin-btn-primary" style={{ backgroundColor: "var(--admin-success)" }}
                                                                onClick={() => { cancelOrder("remboursement"); }}>
                                                                Rembourser le client
                                                            </button>
                                                            <button className="admin-btn admin-btn-danger"
                                                                onClick={() => {
                                                                    Swal.fire({
                                                                        title: "Refuser le remboursement",
                                                                        icon: "warning",
                                                                        showCancelButton: true,
                                                                        confirmButtonText: "Oui, refuser",
                                                                        input: 'text',
                                                                        inputPlaceholder: 'Raison du refus',
                                                                        preConfirm(raisonConfirm) {
                                                                            if (!raisonConfirm) {
                                                                                Swal.showValidationMessage('Veuillez choisir une raison');
                                                                            }
                                                                            setRaison(raisonConfirm);
                                                                        },
                                                                    }).then((result) => {
                                                                        if (result.isConfirmed) {
                                                                            setStripePaymentCancel("Non remboursée")
                                                                        }
                                                                    });
                                                                }}>
                                                                Refuser le remboursement
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                </div>
            )}
        </>
    );
}

export default DetailsCommande;
